import { render, staticRenderFns } from "./UserUploadDocuments.vue?vue&type=template&id=216d54dd&scoped=true&"
import script from "./UserUploadDocuments.vue?vue&type=script&lang=js&"
export * from "./UserUploadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UserUploadDocuments.vue?vue&type=style&index=0&id=216d54dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d54dd",
  null
  
)

export default component.exports